export default {
  pl: {
    messages: {
      required: 'To pole jest wymagane.',
      email: 'Podaj poprawny adres email.',
      min: (field, args) => `To pole musi mieć co najmniej ${args[0]} znaków.`,
      min_value: (field, args) => `Wartość nie może być mniejsza niż ${args[0]}.`,
      regex: 'To pole zawiera dane w niepoprawnym formacie.',
    },
  },
};
